import { render, staticRenderFns } from "./orderRemarkDialog.vue?vue&type=template&id=952d1ede&scoped=true"
import script from "./orderRemarkDialog.vue?vue&type=script&lang=js"
export * from "./orderRemarkDialog.vue?vue&type=script&lang=js"
import style0 from "./orderRemarkDialog.vue?vue&type=style&index=0&id=952d1ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952d1ede",
  null
  
)

export default component.exports